import { FunctionComponent, useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Account, lookupAccount } from '../../api';
import { AuthState, withAuthUser } from '../../auth/AuthProvider';
import AdminMain from './components/AdminMain';

type NewType = AuthState & RouteComponentProps;

type AdminPageProps = NewType;

const AdminPage: FunctionComponent<AdminPageProps> = ({
  authState,
  user,
  history,
  location,
  signOutUser,
}) => {
  const params = new URLSearchParams(location.search);

  const [loadingAccount, setLoadingAccount] = useState(true);
  const [account, setAccount] = useState<Account | null>(null);

  // TODO - smarter queries
  useEffect(() => {
    let mounted = true;
    if (user) {
      setLoadingAccount(true);
      lookupAccount()
        .then((account) => {
          if (mounted) {
            setLoadingAccount(false);
            setAccount(account);
          }
        })
        .catch((err) => {
          if (mounted) {
            setLoadingAccount(false);
            setAccount(null);
          }
          console.error(err);
        });
    }
    return () => {
      mounted = false;
    };
  }, [user]);

  const isLoading =
    authState === 'loading' || (authState === 'signedIn' && loadingAccount);

  const isAuthed = authState === 'signedIn' && !loadingAccount;

  if (isLoading) {
    return (
      <div className="px-5 py-10 font-sans">
        <div className="text-sm text-gray-600">Loading…</div>
      </div>
    );
  } else if (isAuthed && user && account?.isStaff === true) {
    return (
      <div className="fixed inset-0 flex h-screen flex-col justify-start font-sans">
        <div className="flex w-full shrink-0 grow-0 justify-between gap-5 border-0 border-b border-solid border-gray-200 bg-white px-5 py-4">
          <div className="">GoFullPage Admin</div>
          <ul className="my-0 flex items-center text-sm">
            {user ? (
              <li className="mr-2 border-0 border-r border-solid border-gray-200 pr-2">
                <span className="text-gray-600">{user.attributes.email}</span>
              </li>
            ) : null}
            <li className="mr-2 border-0 border-r border-solid border-gray-200 pr-2">
              <Link to="/account">Account</Link>
            </li>
            <li>
              <Link
                to="#"
                onClick={(evt) => {
                  evt.preventDefault();
                  signOutUser();
                }}
              >
                Sign out
              </Link>
            </li>
          </ul>
        </div>
        {params.get('debug') === '1' && (
          <div>
            <h3 className="px-5">Logged in user:</h3>
            <div className="whitespace-pre-wrap px-5">
              AuthState: {authState}
              <br />
              User: {JSON.stringify(user, null, 2)}
              <br />
              Account: {JSON.stringify(account, null)}
            </div>
          </div>
        )}
        <AdminMain
          className="h-0 w-full grow"
          history={history}
          location={location}
          user={user}
        />
      </div>
    );
  } else {
    return (
      <div className="px-5 py-10 font-sans">
        <ul className="m-0 flex items-center text-sm text-gray-600">
          <li className="mr-2 border-0 border-r border-solid border-gray-200 pr-2">
            <Link to="/">Back to home</Link>
          </li>
          <li>
            {isAuthed && user ? (
              <>
                {user.attributes.email}:{' '}
                <Link
                  to="#"
                  onClick={(evt) => {
                    evt.preventDefault();
                    signOutUser();
                  }}
                >
                  sign out
                </Link>
              </>
            ) : (
              <Link to="/account">Log in</Link>
            )}
          </li>
        </ul>
      </div>
    );
  }
};

AdminPage.displayName = 'AdminPage';

export default withAuthUser(AdminPage);
